import {Component, OnInit} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss']
})
export class CookiesComponent implements OnInit {

  isChecked: boolean = false;
  panelOpenState: boolean = false;
  diplayInputField = false;
  displayInputDomain = '';
  domainName = '';
  newCookie = '';
  ignoreCookies = ['__tawkuuid', '_ga', '_ga_ELRKPZ69WL', '_gat_gtag_UA_167633285_1', '_gid', '_hp2_id.4215099365', '_hp2_ses_props.4215099365'];
  cookieList = [];

  constructor(private cookieService: CookieService,
              public platform: LeftpanelComponent) {
  }


  ngOnInit() {
    // this.getCookie();
  }

  addDomain() {
    if (this.domainName !== '') {
      this.cookieService.set(this.domainName, '');
      const obj = {
        domainName: this.domainName,
        cookies: []
      };
      this.cookieList.push(obj);

    } else{
      this.platform.openSnackBar('Please Enter the Domain name.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  getCookie() {
    if (this.isChecked === true) {
      localStorage.setItem('isCookieEnabled', 'true');
      this.cookieList = [];
      const allCookies: {} = this.cookieService.getAll();
      for (const key of this.ignoreCookies) {
        if (allCookies.hasOwnProperty(key)) {
          delete allCookies[key];
        }
      }
      // console.log('cookies', allCookies);
      for (const key in allCookies) {
        const value = allCookies[key];
        const cookiesArr = String(value).split('___');
        const obj = {
          domainName: key,
          cookies: cookiesArr
        };
        this.cookieList.push(obj);
      }
      // console.log(this.cookieList);
    } else {
      localStorage.removeItem('isCookieEnabled');
    }
  }

  removeCookie(domain) {
    // console.log(domain);
    this.cookieService.delete(domain);
    this.getCookie();
  }

  addCookie(domain) {
    this.domainName = '';
    this.diplayInputField = true;
    this.displayInputDomain = domain;
  }

  save(domain) {
    // console.log(this.newCookie, domain);
    if (this.newCookie !== '') {
      let existingCookie = this.cookieService.get(domain);
      // console.log('old cookie', existingCookie);
      if (existingCookie === '') {
        this.cookieService.set(domain, this.newCookie);
        this.getCookie();
        this.newCookie = '';
      } else {
        existingCookie = existingCookie + '___' + this.newCookie;
        this.cookieService.set(domain, existingCookie);
        this.getCookie();
        this.newCookie = '';
      }
    } else {
      this.platform.openSnackBar('Please Enter the Cookie name.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  cancel(domain) {
    this.diplayInputField = false;
    this.displayInputDomain = '';
  }

}
